/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum BookingEngagement {
  NotApplicable = "not_applicable",
  Active = "active",
  AtRisk = "at_risk",
  Returning = "returning",
  Dormant = "dormant",
  Lost = "lost",
}

export function instanceOfBookingEngagement(value: any): boolean {
  for (const key in BookingEngagement) {
    if (Object.prototype.hasOwnProperty.call(BookingEngagement, key)) {
      if (BookingEngagement[key as keyof typeof BookingEngagement] === value) {
        return true;
      }
    }
  }
  return false;
}

export function BookingEngagementFromJSON(json: any): BookingEngagement {
  return BookingEngagementFromJSONTyped(json, false);
}

export function BookingEngagementFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BookingEngagement {
  return json as BookingEngagement;
}

export function BookingEngagementToJSON(value?: BookingEngagement | null): any {
  return value as any;
}

export function BookingEngagementToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): BookingEngagement {
  return value as BookingEngagement;
}
